export default [
  {
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: "field/info/:type",
        name: "field-info-type",
        meta: {
          activeCode: "field-info",
        },
        component: () => import("@/views/_BS/FieldInfo.vue"),
      },

      // ========== 사업장(직접수행)
      {
        path: "field/workplace",
        name: "field-workplace-list",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_BS/FieldWorkplaceList.vue"),
      },
      {
        path: "field/workplace/write",
        name: "field-workplace-create",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_BS/FieldWorkplaceWrite.vue"),
      },
      {
        path: "field/workplace/write/:postId",
        name: "field-workplace-update",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_BS/FieldWorkplaceWrite.vue"),
      },
      {
        path: "field/workplace/info",
        name: "field-workplace-info",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_BS/FieldWorkplaceInfo.vue"),
      },

      // ========== 사업장(용역위탁)
      {
        path: "field/workplace2",
        name: "field-workplace2-list",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_BS/FieldWorkplace2List.vue"),
      },
      {
        path: "field/workplace2/write",
        name: "field-workplace2-create",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_BS/FieldWorkplace2Write.vue"),
      },
      {
        path: "field/workplace2/write/:postId",
        name: "field-workplace2-update",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_BS/FieldWorkplace2Write.vue"),
      },
      {
        path: "field/workplace2/info",
        name: "field-workplace2-info",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_BS/FieldWorkplace2Info.vue"),
      },

      // ========== facility
      {
        path: "field/facility",
        name: "field-facility-list",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_BS/FieldFacilityList.vue"),
      },
      {
        path: "field/facility/write",
        name: "field-facility-create",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_BS/FieldFacilityWrite.vue"),
      },
      {
        path: "field/facility/write/:postId",
        name: "field-facility-update",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_BS/FieldFacilityWrite.vue"),
      },
      {
        path: "field/facility/info",
        name: "field-facility-info",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_BS/FieldFacilityInfo.vue"),
      },

      // ========== field
      {
        path: "field/field",
        name: "field-field-list",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_BS/FieldFieldList.vue"),
      },
      {
        path: "field/field/write",
        name: "field-field-create",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_BS/FieldFieldWrite.vue"),
      },
      {
        path: "field/field/write/:postId",
        name: "field-field-update",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_BS/FieldFieldWrite.vue"),
      },
      {
        path: "field/field/info",
        name: "field-field-info",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_BS/FieldFieldInfo.vue"),
      },

      // ========== public-transportation : 공중교통수단
      {
        path: "field/public-transportation",
        name: "field-public-transportation-list",
        meta: {
          activeCode: "field-public-transportation",
        },
        component: () => import("@/views/_BS/FieldPublicTransportationList.vue"),
      },
      {
        path: "field/public-transportation/write",
        name: "field-public-transportation-create",
        meta: {
          activeCode: "field-public-transportation",
        },
        component: () => import("@/views/_BS/FieldPublicTransportationWrite.vue"),
      },
      {
        path: "field/public-transportation/write/:postId",
        name: "field-public-transportation-update",
        meta: {
          activeCode: "field-public-transportation",
        },
        component: () => import("@/views/_BS/FieldPublicTransportationWrite.vue"),
      },
      {
        path: "field/public-transportation/info",
        name: "field-public-transportation-info",
        meta: {
          activeCode: "field-public-transportation",
        },
        component: () => import("@/views/_BS/FieldPublicTransportationInfo.vue"),
      },

      // ========== facility-public : 공중(다중)이용시설
      {
        path: "field/facility-public",
        name: "field-facility-public-list",
        meta: {
          activeCode: "field-facility-public",
        },
        component: () => import("@/views/_BS/FieldFacilityPublicList.vue"),
      },
      {
        path: "field/facility-public/write",
        name: "field-facility-public-create",
        meta: {
          activeCode: "field-facility-public",
        },
        component: () => import("@/views/_BS/FieldFacilityPublicWrite.vue"),
      },
      {
        path: "field/facility-public/write/:postId",
        name: "field-facility-public-update",
        meta: {
          activeCode: "field-facility-public",
        },
        component: () => import("@/views/_BS/FieldFacilityPublicWrite.vue"),
      },
      {
        path: "field/facility-public/info",
        name: "field-facility-public-info",
        meta: {
          activeCode: "field-facility-public",
        },
        component: () => import("@/views/_BS/FieldFacilityPublicInfo.vue"),
      },

      // ========== school : 학교
      {
        path: "field/school",
        name: "field-school-list",
        meta: {
          activeCode: "field-school",
        },
        component: () => import("@/views/_BS/FieldSchoolList.vue"),
      },
      {
        path: "field/school/write",
        name: "field-school-create",
        meta: {
          activeCode: "field-school",
        },
        component: () => import("@/views/_BS/FieldSchoolWrite.vue"),
      },
      {
        path: "field/school/write/:postId",
        name: "field-school-update",
        meta: {
          activeCode: "field-school",
        },
        component: () => import("@/views/_BS/FieldSchoolWrite.vue"),
      },
      {
        path: "field/school/info",
        name: "field-school-info",
        meta: {
          activeCode: "field-school",
        },
        component: () => import("@/views/_BS/FieldSchoolInfo.vue"),
      },

      // ========== workplace-material : 원료·제조물 사업장
      {
        path: "field/workplace-material",
        name: "field-workplace-material-list",
        meta: {
          activeCode: "field-workplace-material",
        },
        component: () => import("@/views/_BS/FieldWorkplaceMaterialList.vue"),
      },
      {
        path: "field/workplace-material/write",
        name: "field-workplace-material-create",
        meta: {
          activeCode: "field-workplace-material",
        },
        component: () => import("@/views/_BS/FieldWorkplaceMaterialWrite.vue"),
      },
      {
        path: "field/workplace-material/write/:postId",
        name: "field-workplace-material-update",
        meta: {
          activeCode: "field-workplace-material",
        },
        component: () => import("@/views/_BS/FieldWorkplaceMaterialWrite.vue"),
      },
      {
        path: "field/workplace-material/info",
        name: "field-workplace-material-info",
        meta: {
          activeCode: "field-workplace-material",
        },
        component: () => import("@/views/_BS/FieldWorkplaceMaterialInfo.vue"),
      },

      // FieldFacilityComplex
      {
        path: "field/code/:fieldCode",
        name: "field-list-by-code",
        meta: {
          activeCode: "field-list-by-code",
        },
        component: () => import("@/views/_BS/FieldListByCode.vue"),
      },
      {
        path: "field/code/:fieldCode/write",
        name: "field-create-by-code",
        meta: {
          activeCode: "field-create-by-code",
        },
        component: () => import("@/views/_BS/FieldWriteByCode.vue"),
      },
      {
        path: "field/code/:fieldCode/write/:postId",
        name: "field-update-by-code",
        meta: {
          activeCode: "field-update-by-code",
        },
        component: () => import("@/views/_BS/FieldWriteByCode.vue"),
      },
      // ========== 위험성평가 엑셀 업로드 ==========
      {
        path: "riskassessment450",
        name: "riskassessment450",
        meta: {
          activeCode: "riskassessment450",
        },
        component: () => import("@/views/_BS/RiskAssessment.vue"),
      },
      {
        path: "riskassessment460",
        name: "riskassessment460",
        meta: {
          activeCode: "riskassessment460",
        },
        component: () => import("@/views/_BS/RiskAssessment.vue"),
      },
      // ==========
      {
        path: "company/info",
        name: "company-info",
        meta: {
          activeCode: "company-info",
        },
        component: () => import("@/views/_BS/CompanyInfo.vue"),
      },
    ],
  },
];
